import * as api from  '@/api/yxTask/yxTask'
import * as TYPES from './type';

export default {
  //预习任务
  async getTaskList({ commit, state }, { paramets, cb }) {
    const result = await api.reqTaskList(paramets)
    commit(TYPES.TASK_LIST, { result })
    cb && cb()
  },
  async postTaskAdd({ commit, state }, { paramets, cb }) {
    const result = await api.reqTaskAdd(paramets)
    commit(TYPES.TASK_INFO, { result, type:'add' })
    cb && cb()
  },
  async putTaskEdit({ commit, state }, { paramets, cb }) {
    const result = await api.reqTaskEdit(paramets)
    commit(TYPES.TASK_INFO, { result, type:'edit' })
    cb && cb()
  },
  async putTaskEditStatus({ commit, state }, { paramets, cb }) {
    const result = await api.reqTaskEditStatus(paramets)
    commit(TYPES.TASK_INFO, { result, type:'editStatus' })
    cb && cb()
  },
  async delTaskDel({ commit, state }, { paramets, cb }) {
    const result = await api.reqTaskDel(paramets)
    commit(TYPES.TASK_INFO, { result, type:'del' })
    cb && cb()
  },
  async delTaskDeleteBatch({ commit, state }, { paramets, cb }) {
    const result = await api.reqTaskDeleteBatch(paramets)
    commit(TYPES.TASK_INFO, { result, type:'deleteBatch' })
    cb && cb()
  },
  async getTaskDetail({ commit, state }, { paramets, cb }) {
    const result = await api.reqTaskDetail(paramets)
    commit(TYPES.TASK_INFO, { result, type:'detail' })
    cb && cb()
  },
  async getTaskCount({ commit, state }, { paramets, cb }) {
    const result = await api.reqTaskCount(paramets)
    commit(TYPES.TASK_INFO, { result, type:'count' })
    cb && cb()
  },
  async getTaskClassList({ commit, state }, { paramets, cb }) {
    const result = await api.reqTaskClassList(paramets)
    commit(TYPES.TASK_INFO, { result, type:'classList' })
    //console.log(result)
    cb && cb()
  },
  async getTaskCatelogList({ commit, state }, { paramets, cb }) {
    const result = await api.reqTaskCatelogList(paramets)
    commit(TYPES.TASK_INFO, { result, type:'catelogList' })
    cb && cb()
  },
  async getTaskTestList({ commit, state }, { paramets, cb }) {
    const result = await api.reqTaskTestList(paramets)
    commit(TYPES.TASK_INFO, { result, type:'testList' })
    cb && cb()
  },
  async getTaskTestListStudent({ commit, state }, { paramets, cb }) {
    const result = await api.reqTaskTestListStudent(paramets)
    commit(TYPES.TASK_LIST_STUDENT, { result })
    cb && cb()
  },
  async getTaskCourseList({ commit, state }, { paramets, cb }) {
    const result = await api.reqTaskCourseList(paramets)
    commit(TYPES.COURSE_LIST, { result })
    cb && cb()
  },
  async getTaskPlanList({ commit, state }, { paramets, cb }) {
    const result = await api.reqTaskPlanList(paramets)
    commit(TYPES.PLAN_LIST, { result })
    cb && cb()
  },
  async getTaskCourseClassList({ commit, state }, { paramets, cb }) {
    const result = await api.reqTaskCourseClassList(paramets)
    commit(TYPES.CLASS_LIST, { result })
    cb && cb()
  },
  async getTaskCourseTreeList({ commit, state }, { paramets, cb }) {
    const result = await api.reqTaskCourseTreeList(paramets)
    commit(TYPES.TREE_LIST, { result })
    cb && cb()
  },
  async getTaskTalkList({ commit, state }, { paramets, cb }) {
    const result = await api.reqTaskTalkList(paramets)
    commit(TYPES.MESS_LIST, { result })
    cb && cb()
  },
  async postTaskTalkAdd({ commit, state }, { paramets, cb }) {
    const result = await api.reqTaskTalkAdd(paramets)
    commit(TYPES.MESS_ADD, { result })
    cb && cb()
  },
  async delTaskTalkDel({ commit, state }, { paramets, cb }) {
    const result = await api.reqTaskTalkDel(paramets)
    commit(TYPES.MESS_DEL, { result })
    cb && cb()
  },
  async putTaskTalkRead({ commit, state }, { paramets, cb }) {
    const result = await api.reqTaskTalkRead(paramets)
    commit(TYPES.MESS_READ, { result })
    cb && cb()
  },
  async getTaskTestStuList({ commit, state }, { paramets, cb }) {
    const result = await api.reqTaskTestStuList(paramets)
    commit(TYPES.TASK_TEST_STU, { result })
    cb && cb()
  },
  async getTaskTestDetails({ commit, state }, { paramets, cb }) {
    const result = await api.reqTaskTestDetails(paramets)
    commit(TYPES.TASK_TEST_LIST, { result })
    cb && cb()
  },
  async editEndTime(context,{paramets,cb}){
    const result = await api.reqEditEndTime(paramets);
    context.commit(TYPES.EDIT_TASK_DATE,result)
    cb && cb()
  },
}
